<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { barTitle, useBarSlot } from "@/design/composables/use-bar-title";
import { navMessages } from "./i18n/nav";
import { NAV_ITEMS } from "./nav-items";

/**
 * O nome da tela ao lado do ☰ no telefone (dono, 25/10): é o "onde estou" que o
 * logo diz no computador e que, sem ele, a barra não dizia. O nome é o MESMO da
 * linha do menu lateral — o endereço mais longo que contém o atual — quando a
 * página não publica o seu (`use-bar-title.ts`).
 */
const { t } = useI18n({ useScope: "local", inheritLocale: true, messages: navMessages });
const route = useRoute();
useBarSlot();

const title = computed(() => {
	// O título da própria página, quando ela tem `PageHeader`; senão, o nome do menu.
	const own = barTitle();
	if (own) return own;
	const path = route.path;
	const hit = NAV_ITEMS.filter(
		(item) =>
			!item.to.includes("?") &&
			(item.to === "/" ? path === "/" : path === item.to || path.startsWith(`${item.to}/`)),
	).sort((a, b) => b.to.length - a.to.length)[0];
	return hit ? t(hit.labelKey) : "";
});
</script>

<template>
	<span v-if="title" class="truncate text-base font-medium text-fg">{{ title }}</span>
</template>
